export const iconFontAwesomeTransportationPaperPlane = (
	<i className="fa-solid fa-paper-plane"></i>
);
